import { Link } from 'react-router-dom';
import { ErrorState, Loading } from '../../components/States';
import { useAdminOverview } from '../../hooks/api-hooks';
import { formatPrice } from '../../lib/format';

export function AdminOverviewPage() {
  const overview = useAdminOverview();

  if (overview.isPending) return <Loading label="Đang tải bảng điều khiển…" />;
  if (overview.error) return <ErrorState error={overview.error} />;

  const data = overview.data;
  return (
    <section className="admin-page">
      <header className="admin-page-header">
        <div>
          <h1>Tổng quan</h1>
          <p>Theo dõi nội dung, học viên và công cụ bán hàng trong một nơi.</p>
        </div>
        <Link className="btn btn-small" to="/admin/khoa-hoc">Thêm sản phẩm</Link>
      </header>

      <div className="admin-stats">
        <article><strong>{data.courseCount}</strong><span>Khóa học</span></article>
        <article><strong>{data.skillCount}</strong><span>Skill</span></article>
        <article><strong>{data.studentCount}</strong><span>Học viên</span></article>
        <article><strong>{data.paidOrderCount}</strong><span>Đơn đã thanh toán</span></article>
        <article className="admin-stat-wide"><strong>{formatPrice(data.paidRevenue)}</strong><span>Doanh thu đã ghi nhận</span></article>
      </div>

      <div className="admin-overview-grid">
        <Link to="/admin/don-hang" className="admin-action-card">
          <span>Giao dịch cần kiểm tra</span>
          <strong>{data.reviewTransactionCount}</strong>
          <small>Khớp thủ công với đơn hàng hoặc đánh dấu bỏ qua</small>
        </Link>
        <Link to="/admin/workshop" className="admin-action-card">
          <span>Đăng ký workshop</span>
          <strong>{data.workshopRegistrationCount}</strong>
          <small>Xác nhận và cập nhật trạng thái tham dự</small>
        </Link>
        <Link to="/admin/voucher" className="admin-action-card">
          <span>Voucher đang hoạt động</span>
          <strong>{data.activeCouponCount}</strong>
          <small>Tạo mã giảm giá theo từng khóa học</small>
        </Link>
        <Link to="/admin/ma-kich-hoat" className="admin-action-card">
          <span>Mã kích hoạt còn hiệu lực</span>
          <strong>{data.activeActivationCodeCount}</strong>
          <small>Cấp quyền học mà không cần đơn hàng</small>
        </Link>
        <Link to="/admin/trang-chu" className="admin-action-card">
          <span>Nội dung trang chủ</span>
          <strong>Sửa</strong>
          <small>Thay chữ, ảnh và video nền</small>
        </Link>
      </div>
    </section>
  );
}
